import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigColumnDef } from '../../configuration/catalogs/config-table.component';

@Component({
  selector: 'app-config-transaction-codes',
  template: `<app-config-table
    tableName="Transaction Codes"
    [columns]="columns"
    permissionKey="Config.Manage"
    sortField="shortDescription"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate">
  </app-config-table>`,
})
export class TransactionCodeConfigComponent {
  columns: ConfigColumnDef[] = [
    { field: 'shortDescription',          label: 'Short Description',           type: 'text',     required: true, maxLength: 50 },
    { field: 'description',               label: 'Description',                 type: 'textarea',               maxLength: 255 },
    { field: 'invoiceDescription',        label: 'Invoice Description',         type: 'textarea',               maxLength: 255 },
    { field: 'isCharge',                  label: 'Type',                        type: 'select',   required: true,
      selectOptions: [
        { value: true,  label: 'Charge (customer pays)' },
        { value: false, label: 'Credit (WMC pays out)'  },
      ]
    },
    { field: 'defaultAmount',             label: 'Default Amount ($)',           type: 'number' },
    { field: 'defaultServiceTimeSeconds', label: 'Default Service Time (sec)',   type: 'number' },
    { field: 'sortOrder',                 label: 'Sort',                         type: 'number' },
  ];

  private buildPayload(d: any) {
    return {
      shortDescription: d.shortDescription,
      description: d.description,
      invoiceDescription: d.invoiceDescription,
      isCharge: d.isCharge ?? true,
      defaultAmount: d.defaultAmount ?? 0,
      defaultServiceTimeSeconds: d.defaultServiceTimeSeconds ?? 25,
      sortOrder: d.sortOrder,
    };
  }

  load       = () => this.http.get<any[]>('/api/transaction-codes');
  create     = (d: any) => this.http.post('/api/transaction-codes', this.buildPayload(d));
  update     = (id: any, d: any) => this.http.put(`/api/transaction-codes/${id}`, {
    ...this.buildPayload(d),
    isActive: d.isActive ?? true,
  });
  deactivate = (id: any) => this.http.delete<void>(`/api/transaction-codes/${id}`);

  constructor(private http: HttpClient) {}
}
